import ArrowUpIcon from '@flipster/react/icon/generated/ArrowUpIcon';
import { circle } from '@flipster/styled-system/patterns';

export const ScrollToTopButton = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  return (
    <button
      type='button'
      className={circle({
        pos: 'fixed',
        right: 26,
        bottom: 26,
        size: 44,
        bg: 'background.default.level-4',
        color: 'inverse.white',
        display: {
          base: 'none',
          tablet: 'block',
        },
      })}
      onClick={scrollToTop}
    >
      <ArrowUpIcon />
    </button>
  );
};
